/* eslint-disable react/prefer-es6-class, react/prefer-stateless-function */
import React from 'react';
import Localization from 'es6/services/localization';

export default React.createClass({
  displayName: 'StudyAllRibbon',

  render() {
    return (
      <div className="ribbon ribbon-corner">
        <div className="ribbon-study-all ribbon-message">{Localization.t('ribbon-study-all')}</div>
      </div>
    );
  },
});
